import React, { type FunctionComponent, Fragment } from 'react'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import AppHeader from 'legacy/components/AppHeader'
import { ReportsBreadcrumbs } from 'domains/reports/components/breadcrumbs/ReportsBreadcrumbs'
import { ReportsNormalizedReportsList } from 'domains/reports/components/normalized-reports-list/ReportsNormalizedReportsList'

interface Props
  extends DashRouteComponentProps<{
    /*
    Add here any properties that you expect to come from the route. For instance,

    id: string
  */
    partner_id: string
    warehouse_id: string
  }> {}

export const ReportsNormalizedReportsListPage: FunctionComponent<Props> = ({ match }) => {
  const partnerId = match?.params?.partner_id
  const retailerId = match?.params?.warehouse_id

  return (
    <Fragment>
      <DocumentTitle titleId="reportsDomain.normalizedReports.list.pageTitle" />

      <AppHeader title={<ReportsBreadcrumbs />} />

      <ReportsNormalizedReportsList partnerId={partnerId} retailerId={retailerId} />
    </Fragment>
  )
}
